import { render, staticRenderFns } from "./org-tree.vue?vue&type=template&id=280246dc&scoped=true&"
import script from "./org-tree.vue?vue&type=script&lang=ts&"
export * from "./org-tree.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280246dc",
  null
  
)

export default component.exports